<template>
    <aside>
        <header>
            <figure class="image is-3by2">
                <img :src="communityImageUrl" class="lb-community-image" />
            </figure>
            <!--<figure v-if="community.partner" class="image lb-community-partner-image px-6 pt-5">
                <img
                    :alt="community.partner.name"
                    :src="community.partner.image.url"
                    loading="lazy"
                />
            </figure>-->
        </header>
        <main class="menu">
            <ul class="menu-list px-3 pt-5">
                <hr class="navbar-divider has-background-grey-lighter" />

                <li
                    class="
                        is-capitalized
                        has-text-weight-bold
                        is-size-6
                        mb-1
                        pb-1
                    "
                >
                    <div class="level is-mobile">
                        <div class="level-left is-shrinkable">
                            <div class="level-item is-shrinkable">
                                <router-link
                                    v-t="'Community.feed'"
                                    :to="{
                                        name: 'community',
                                    }"
                                    exact
                                />
                                <p
                                    v-if="community.pendingPosts > 0"
                                    class="is-relative lb-margin-badge"
                                >
                                    <span
                                        class="
                                            badge
                                            is-size-7
                                            has-background-pink-red
                                        "
                                        >{{ community.pendingPosts }}</span
                                    >
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
                <hr class="navbar-divider has-background-grey-lighter" />
                <div v-if="showCalendar">
                    <li class="is-size-6 mb-1 pb-1">
                        <router-link
                            v-t="'Community.calendar'"
                            :to="{
                                name: 'calendar',
                            }"
                            class="is-capitalized-first has-text-weight-bold"
                            exact
                        />
                    </li>

                    <hr class="navbar-divider has-background-grey-lighter" />
                </div>
                <div v-if="(folders && folders.length) || isAdmin">
                    <menu-section
                        :items="folders"
                        :title="$t('Community.folders_menu_label')"
                        :is-admin="isAdmin"
                        :link-params="{
                            routeName: 'folder',
                        }"
                        @create="createFolder"
                        @sort="dragEndHandler"
                        @editItem="editFolder"
                        @deleteItem="removeFolder"
                    />
                    <hr class="navbar-divider has-background-grey-lighter" />
                </div>

                <!-- LBY2-152 remove circle access-->
                <!--<div v-if="isAdmin || (circles && circles.length)">
                    <menu-section
                        :items="circles"
                        :title="$t('Community.agora')"
                        :is-admin="isAdmin"
                        :link-params="{
                            routeName: 'circle',
                        }"
                        @create="createCircle"
                        @sort="circleDragEndHandler"
                        @editItem="editCircle"
                        @deleteItem="removeCircle"
                    />
                    <hr class="navbar-divider has-background-grey-lighter" />
                </div>-->

                <div v-if="isAdmin || (links && links.length)">
                    <!--TODO: replace this section with  menu section component-->
                    <nav class="level mb-2 py-2">
                        <div class="level-left">
                            <div class="level-item">
                                <p
                                    v-t="'Community.links_menu_label'"
                                    class="menu-label pl-3"
                                />
                            </div>
                        </div>
                        <div class="level-right">
                            <a
                                v-if="isAdmin"
                                v-t="'Buttons.add'"
                                class="
                                    menu-label
                                    has-text-primary has-text-weight-bold
                                "
                                @click="$emit('createLink')"
                            />
                        </div>
                    </nav>

                    <draggable
                        :list="links"
                        :disabled="!isAdmin"
                        @end="linkDragEndHandler"
                    >
                        <li
                            v-for="(link, index) in links"
                            :key="index"
                            class="has-text-weight-bold is-size-6 mb-1 pb-1"
                        >
                            <div class="level">
                                <div class="level-left">
                                    <a
                                        :href="link.url"
                                        class="level-item"
                                        target="_blank"
                                        >{{ link.title || link.url }}</a
                                    >
                                </div>
                                <div class="level-right">
                                    <div class="level-item" v-if="isAdmin">
                                        <div
                                            class="
                                                dropdown
                                                is-right
                                                is-hoverable
                                                is-pulled-right
                                            "
                                        >
                                            <span
                                                class="
                                                    icon
                                                    is-small
                                                    dropdown-trigger
                                                    has-text-grey
                                                    mt-1
                                                "
                                            >
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-24px
                                                        mdi-dots-vertical
                                                    "
                                                    aria-hidden="true"
                                                />
                                            </span>
                                            <div
                                                class="dropdown-menu"
                                                role="menu"
                                            >
                                                <div class="dropdown-content">
                                                    <a
                                                        v-t="
                                                            'Folders.dropdown_option_delete'
                                                        "
                                                        class="dropdown-item"
                                                        @click="
                                                            $emit(
                                                                'removeLink',
                                                                link
                                                            )
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </draggable>
                    <hr class="navbar-divider has-background-grey-lighter" />
                </div>

                <div>
                    <li class="is-size-6 mb-1 pb-1">
                        <router-link
                            v-t="'Community.participants'"
                            :to="{
                                name: 'participants',
                            }"
                            class="is-capitalized-first has-text-weight-bold"
                            exact
                        />
                    </li>

                    <hr class="navbar-divider has-background-grey-lighter" />
                </div>

                <div v-if="isMember">
                    <li class="is-size-6 mb-1 pb-1">
                        <a
                            v-t="'Buttons.configuration'"
                            class="is-capitalized has-text-weight-bold"
                            @click="$emit('openConfiguration')"
                        ></a>
                    </li>

                    <hr class="navbar-divider has-background-grey-lighter" />
                </div>

                <div v-if="isAdmin">
                    <li class="is-size-6 mb-1 pb-1">
                        <a
                            v-if="isAdmin"
                            v-t="'Buttons.settings'"
                            class="is-capitalized has-text-weight-bold"
                            @click="$emit('openSettings')"
                        ></a>
                    </li>

                    <hr class="navbar-divider has-background-grey-lighter" />
                </div>
            </ul>
        </main>
        <!--footer>footer</footer-->
    </aside>
</template>

<script>
import draggable from 'vuedraggable';
import _ from 'underscore';
import { createCircle } from '@/services/API';
import CommunitySideMenuSection from '@/components/CommunitySideMenuSection';
export default {
    components: {
        draggable,
        menuSection: CommunitySideMenuSection,
    },
    props: {},
    data() {
        return {};
    },
    computed: {
        community() {
            return this.$store.getters.community;
        },
        communityImageUrl() {
            return this.$store.getters.communityImageUrl;
        },
        showCalendar() {
            return this.$store.getters.community.settings
                ? this.$store.getters.community.settings.showCalendar
                : false;
        },
        hasContent() {
            if (this.community.activities && this.community.activities.length) {
                return true;
            }
            return false;
        },
        isAdmin() {
            return this.community.accessLevel == 'administrator';
        },
        folders() {
            const folders =
                _.sortBy(this.community.activityFolders, (item) => {
                    return +item.order;
                }) || [];
            return _.map(folders, (folder) => {
                folder.badgeCount = folder.pendingActivities;
                return folder;
            });
        },
        links() {
            return this.community.links || [];
        },
        circles() {
            const circles = this.community.circles || [];
            return _.map(circles, (circle) => {
                circle.badgeCount = circle.pendingMessages;
                return circle;
            });
        },
        isMember() {
            return this.$store.getters.community.accessLevel !== 'read';
        },
    },
    methods: {
        dragEndHandler(e) {
            const folder = this.folders[e.newIndex];
            folder.order = e.newIndex;
            this.$store
                .dispatch('updateActivityFolder', {
                    object: folder,
                    id: this.$route.params.communityId,
                })
                .then(() => {
                    //this.isEditing = false;
                })
                .catch((e) => {
                    console.error('error editing folder', e);
                    alert(e);
                    return;
                });
        },
        linkDragEndHandler() {
            this.$emit('updateLinksOrder', this.links);
        },
        circleDragEndHandler() {
            this.$emit('updateCircleOrder', this.circles);
        },
        createFolder() {
            let name = window.prompt(
                this.$t('Folders.create_folder'),
                undefined
            );
            if (!name || !name.length) {
                return;
            }
            this.$store
                .dispatch('addActivityFolder', {
                    object: { name, order: this.folders.length },
                    id: this.$route.params.communityId,
                })
                .then(() => {})
                .catch((e) => {
                    console.error('error adding folder', e);
                    alert(e);
                    return;
                });
        },
        createCircle() {
            let name = window.prompt(
                this.$t('Community.create_circle'),
                undefined
            );
            if (!name || !name.length) {
                return;
            }

            createCircle(this.$route.params.communityId, {
                name,
                description: '',
            }).then(({ data }) => {
                if (this.community.circles) {
                    this.community.circles.push(data);
                } else {
                    this.community.circles = [data];
                }
            });
        },
        editFolder(folder) {
            let name = window.prompt(
                this.$t('Folders.create_folder'),
                folder.name
            );
            if (!name || !name.length) {
                return;
            }
            folder.name = name;
            this.$store
                .dispatch('updateActivityFolder', {
                    object: folder,
                    id: this.$route.params.communityId,
                })
                .then(() => {
                    //this.isEditing = false;
                })
                .catch((e) => {
                    console.error('error adding folder', e);
                    alert(e);
                    return;
                });
        },
        removeFolder(folder) {
            if (confirm(this.$t('Folders.delete_confirmation_message'))) {
                this.$store
                    .dispatch('deleteActivityFolder', {
                        folderId: folder._id,
                        communityId: this.$route.params.communityId,
                    })
                    .then(() => {
                        //this.isEditing = false;
                    })
                    .catch((e) => {
                        console.error('error adding folder', e);
                        alert(e);
                        return;
                    });
            }
        },

        editCircle(circle) {
            let name = window.prompt(
                this.$t('Community.create_circle'),
                circle.name
            );
            if (!name || !name.length) {
                return;
            }
            circle.name = name;
            this.$store
                .dispatch('updateCircle', {
                    object: circle,
                    id: this.$route.params.communityId,
                })
                .then(() => {
                    //this.isEditing = false;
                })
                .catch((e) => {
                    console.error('error updating circle', e);
                    alert(e);
                    return;
                });
        },
        removeCircle(circle) {
            if (
                confirm(this.$t('Community.delete_circle_confirmation_message'))
            ) {
                this.$store
                    .dispatch('deleteCircle', {
                        circleId: circle._id,
                        communityId: this.$route.params.communityId,
                    })
                    .then(() => {
                        console.log('active circles', this.circles.length);
                        //this.isEditing = false;
                        if (
                            this.$route.params.id &&
                            this.$route.params.id == circle._id
                        ) {
                            if (this.circles.length) {
                                this.$router.push({
                                    name: 'circle',
                                    params: { circleId: this.circles[0]._id },
                                });
                            }
                        }
                    })
                    .catch((e) => {
                        console.error('error removing circle', e);
                        alert(e);
                        return;
                    });
            }
        },
    },
};
</script>

<style scoped>
.menu-list {
    list-style: none;
}

figure {
    overflow: hidden;
}
.lb-community-image {
    object-fit: cover;
}
.lb-community-partner-image {
    max-height: 6rem;
}

aside {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

aside ::-webkit-scrollbar {
    display: none;
}

main {
    flex-grow: 1;
    flex-basis: auto;
    height: 0px;
    overflow-y: scroll;
}

header,
main,
footer {
    flex-shrink: 0;
}

.navbar-divider {
    height: 1px;
}

.lb-margin-badge {
    margin-left: -5px;
    margin-top: -10px;
}
</style>
